import {
  type TPayGoDetailsDTO,
  payGoSchema,
} from '~/domain/contract/api/dto/payGoDTO';

export const PayGoContractModel = (data: TPayGoDetailsDTO) =>
  payGoSchema.parse(data);
